import React from "react";
import { Link } from "react-router-dom";
import { NAV_ENABLED_APPS } from "../../../config/config.js";
import { EraIcon } from "../../../styles/Icon.js";
import { getPhrase } from "../../../utils/Languages.js";
import "./ExploreApps.css";
/*
 * Same parse and the same fallback list as RedesignShell. Copied on purpose:
 * the shell owns navigation, and this section only reads the list to drop
 * cards. The homepage's Browse Datasets action reads it too.
 */
const NAV_COMPONENT_FALLBACK = [
    "era-search",
    "unified-era-search",
    "era-compatibility-check",
    "era-dataset-explorer",
    "era-notifications",
    "era-dataset-manager",
    "era-endpoint",
    "era-datastories",
    "era-vocabulary",
];
const HOME_CARDS = [
    {
        to: "/unified-search",
        icon: "magnifying-glass",
        titleKey: "homeCardUnifiedSearchTitle",
        descriptionKey: "homeCardUnifiedSearchDescription",
    },
    {
        flag: "era-dataset-explorer",
        to: "/dataset-explorer",
        icon: "database",
        titleKey: "homeCardDatasetsExplorerTitle",
        descriptionKey: "homeCardDatasetsExplorerDescription",
    },
    {
        flag: "era-datastories",
        to: "/data-stories",
        icon: "book-open",
        titleKey: "homeCardDataStoriesTitle",
        descriptionKey: "homeCardDataStoriesDescription",
    },
    {
        flag: "era-compatibility-check",
        to: "/route-compatibility",
        icon: "code-branch",
        titleKey: "homeCardRouteSimulationTitle",
        descriptionKey: "homeCardRouteSimulationDescription",
    },
];
function readEnabledComponents() {
    try {
        const enabledConfig = JSON.parse(atob(NAV_ENABLED_APPS));
        return enabledConfig.components;
    }
    catch {
        return NAV_COMPONENT_FALLBACK;
    }
}
const enabledComponents = readEnabledComponents();
export function isNavComponentEnabled(flag) {
    return enabledComponents.includes(flag);
}
export function ExploreApps() {
    const cards = HOME_CARDS.filter((card) => card.flag === undefined || enabledComponents.includes(card.flag));
    return (React.createElement("section", { className: "redesign-home-explore" },
        React.createElement("div", { className: "redesign-home-explore-inner" },
            React.createElement("h2", { className: "redesign-home-explore-title" }, getPhrase("homeExploreTitle")),
            React.createElement("ul", { className: "redesign-home-grid" }, cards.map((card) => {
                const title = getPhrase(card.titleKey);
                return (React.createElement("li", { key: card.to, className: "redesign-home-card" },
                    React.createElement(EraIcon, { faName: card.icon, className: "redesign-home-card-icon", style: { margin: "var(--era-space-0)" } }),
                    React.createElement("h3", { className: "redesign-home-card-title" }, title),
                    React.createElement("p", { className: "redesign-home-card-description" }, getPhrase(card.descriptionKey)),
                    React.createElement(Link, { className: "redesign-home-card-open", to: card.to, "aria-label": `${getPhrase("homeCardOpen")} ${title}` },
                        getPhrase("homeCardOpen"),
                        React.createElement("span", { "aria-hidden": "true" }, " \u2192"))));
            })))));
}
